import { PaymentRequest } from '@melio/javascript-sdk';
import { convertCentsToDollars } from '@melio/platform-utils';

export const convertPaymentRequestCentsToDollars = (data: PaymentRequest) =>
  convertCentsToDollars(data, ['totalAmount']);
